// Слаги тестов, которыми разделы админки отличают один тест от другого.
// Должны совпадать со слагами на сервере
// (server/src/modules/placement-test/config/testKinds.config.js).

// Взрослый Placement Test: полный диагностический тест с CEFR-результатом.
export const ADULT_PLACEMENT_TEST_SLUG = 'placement-test-ubc';

// Мини-опросник на главной: три вопроса без правильных ответов.
export const QUICK_PLACEMENT_TEST_SLUG = 'quick-placement-test-ubc';

// Детский диагностический тест: отдельный набор вопросов на 40 баллов.
export const KIDS_DIAGNOSTIC_TEST_SLUG = 'kids-diagnostic-test-ubc';
